import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ba0bbe76"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba0bbe76')) {
      api.createRecord('ba0bbe76', component.options)
    } else {
      api.reload('ba0bbe76', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ba0bbe76", function () {
      api.rerender('ba0bbe76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/pages/leads-extract/index.vue"
export default component.exports